// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalAlignBottomOutlinedSvg from "@ant-design/icons-svg/es/asn/VerticalAlignBottomOutlined";
import AntdIcon from '../components/AntdIcon';

var VerticalAlignBottomOutlined = function VerticalAlignBottomOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignBottomOutlinedSvg
  }));
};

VerticalAlignBottomOutlined.displayName = 'VerticalAlignBottomOutlined';
export default React.forwardRef(VerticalAlignBottomOutlined);